import  secureLocalStorage  from  "react-secure-storage";
export function get_user_permissions(key) {
    var userData = secureLocalStorage.getItem("userData")
    return userData?.data[key];
}
export function get_all_permissions() {
    var userData = secureLocalStorage.getItem("userData")
    return userData?.data;
}